/**
 * MODULE: domain/sales-presentations/frontend/utils/normalizeContentSchema
 * PURPOSE: Normalize API-loaded content_schema so slides always have a defined layers array in memory.
 * DEPENDENCIES: ../api/types (ContentSchema, RenderedSlide)
 * PUBLIC_API: normalizeContentSchema, normalizeRenderedSlide, normalizePresentationFromApi
 * SIDE_EFFECTS: none — pure data shaping
 * AGENT_SAFETY: 🟢 SAFE
 * FILE_SIZE: ~28 / 150
 */

import type { ContentSchema, Presentation, RenderedSlide } from '../api/types';

export function normalizeRenderedSlide(slide: RenderedSlide): RenderedSlide {
  return { ...slide, layers: slide.layers ?? [] };
}

export function normalizeContentSchema(schema: ContentSchema | null | undefined): ContentSchema {
  const slides = schema && Array.isArray(schema.slides) ? schema.slides : [];
  return { slides: slides.map(normalizeRenderedSlide) };
}

/** Shape API presentation payloads so `content_schema.slides[*].layers` is always an array. */
export function normalizePresentationFromApi(presentation: Presentation): Presentation {
  return {
    ...presentation,
    content_schema: normalizeContentSchema(presentation.content_schema),
  };
}
